import { render, staticRenderFns } from "./ChoixClient.vue?vue&type=template&id=22ac89a1&scoped=true&"
import script from "./ChoixClient.vue?vue&type=script&lang=js&"
export * from "./ChoixClient.vue?vue&type=script&lang=js&"
import style0 from "./ChoixClient.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChoixClient.vue?vue&type=style&index=1&id=22ac89a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac89a1",
  null
  
)

export default component.exports